import { render } from "./DeletedMedicationTypes.vue?vue&type=template&id=25cbc7f7&scoped=true"
import script from "./DeletedMedicationTypes.vue?vue&type=script&lang=js"
export * from "./DeletedMedicationTypes.vue?vue&type=script&lang=js"

import "./DeletedMedicationTypes.vue?vue&type=style&index=0&id=25cbc7f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25cbc7f7"]])

export default __exports__